import { render } from "./inputTag.vue?vue&type=template&id=05eebc42"
import script from "./inputTag.vue?vue&type=script&setup=true&lang=js"
export * from "./inputTag.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/inputTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05eebc42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05eebc42', __exports__)) {
    api.reload('05eebc42', __exports__)
  }
  
  module.hot.accept("./inputTag.vue?vue&type=template&id=05eebc42", () => {
    api.rerender('05eebc42', render)
  })

}


export default __exports__